/* eslint-disable */

import React, { useEffect, useState } from 'react';
import { Link, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import { useDetectClickOutside } from 'react-detect-click-outside';
import ModalPopupMessage from '../../components/modal/ModalPopupMessage';
import Tabs from '../../components/tabs/Tabs';

import MyShop_Seller_BusinessOverview from './seller/MyShop_Seller_BusinessOverview';
import MyShop_Seller_Deliver from './seller/MyShop_Seller_Deliver';
import MyShop_Seller_History from './seller/MyShop_Seller_History';
import MyShop_Seller_Income from './seller/MyShop_Seller_Income';
import MyShop_Seller_JobToDo from './seller/MyShop_Seller_JobToDo';
import MyShop_Seller_MyProduct from './seller/MyShop_Seller_MyProduct';
import MyShop_Seller_NewProduct from './seller/MyShop_Seller_NewProduct';
import MyShop_Seller_Payment from './seller/MyShop_Seller_Payment';
import MyShop_Seller_Return from './seller/MyShop_Seller_Return';
import MyShop_Seller_Transport from './seller/MyShop_Seller_Transport';

import MyShop_Buyer_Deliver from './buyer/MyShop_Buyer_Deliver';
import MyShop_Buyer_History from './buyer/MyShop_Buyer_History';
import MyShop_Buyer_Payment from './buyer/MyShop_Buyer_Payment';
import MyShop_Buyer_Recieve from './buyer/MyShop_Buyer_Recieve';
import MyShop_Buyer_Refund from './buyer/MyShop_Buyer_Refund';
import MyShop_Buyer_Return from './buyer/MyShop_Buyer_Return';

import MyShop_Tools_Chat from './tools/MyShop_Tools_Chat';

import PropTypes from 'prop-types';
import AccessRestrictedMessage from '../../components/message/AccessRestrictedMessage';
import { USER_TYPE } from '../../helper/constant/userType';
import { useExpireAlert } from '../../hooks/useExpireAlert';
import './Admin.css';
import './MyShopStyle.css';
import './SubPriceTable.css';

function MyShopPage(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasExpireAlert } = useExpireAlert(props.permitdata);

  const [menu_root, setmenu_root] = useState('');
  const [submenu_root, setSubmenu_root] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [force_tab, setForce_tab] = useState('');
  const [submenu_mode, setSubmenu_mode] = useState('usersconfig');
  const [data_shoporderlist, setData_shoporderlist] = useState([]);
  const [data_shopitemlist, setData_shopitemlist] = useState([]);

  const [data_shoporder_seller_payment, setData_shoporder_seller_payment] = useState([]);
  const [data_shoporder_seller_deliver, setData_shoporder_seller_deliver] = useState([]);
  const [data_shoporder_seller_transport, setData_shoporder_seller_transport] = useState([]);
  const [data_shoporder_seller_return, setData_shoporder_seller_return] = useState([]);
  const [data_shoporder_seller_income, setData_shoporder_seller_income] = useState([]);

  const [data_shoporder_buyer_payment, setData_shoporder_buyer_payment] = useState([]);
  const [data_shoporder_buyer_deliver, setData_shoporder_buyer_deliver] = useState([]);
  const [data_shoporder_buyer_recieve, setData_shoporder_buyer_recieve] = useState([]);
  const [data_shoporder_buyer_return, setData_shoporder_buyer_return] = useState([]);
  const [data_shoporder_buyer_refund, setData_shoporder_buyer_refund] = useState([]);

  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [downloadRange, setDownloadRange] = useState({ start: '', end: '' });

  function formatDateInput(d) {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  const resetNavbarClasses = () => {
    const elSale = document.getElementById('nav-sale');
    const elSalePop = document.getElementById('nav-sale-pop');
    const elBuy = document.getElementById('nav-buy');
    const elBuyPop = document.getElementById('nav-buy-pop');
    const elHelp = document.getElementById('nav-help');
    const elHelpPop = document.getElementById('nav-help-pop');

    if (elSale) elSale.className = 'nav-item hs-has-mega-menu u-header__nav-item';
    if (elSalePop) elSalePop.className = 'hs-mega-menu w-100 u-header__sub-menu animated hs-position-left fadeOut d-none';
    if (elBuy) elBuy.className = 'nav-item hs-has-mega-menu u-header__nav-item';
    if (elBuyPop) elBuyPop.className = 'hs-mega-menu w-100 u-header__sub-menu animated hs-position-left fadeOut d-none';
    if (elHelp) elHelp.className = 'nav-item hs-has-mega-menu u-header__nav-item';
    if (elHelpPop) elHelpPop.className = 'hs-mega-menu w-100 u-header__sub-menu animated hs-position-left fadeOut d-none';
  };

  useEffect(() => {
    if (location.pathname.search('/seller') > -1) {
      setmenu_root('ระบบขายสินค้า');
    }
    if (location.pathname.search('/buyer') > -1) {
      setmenu_root('ระบบซื้อสินค้า');
    }

    if (location.pathname.search('/seller/businessoverview') > -1) {
      setSubmenu_mode('seller/businessoverview');
      setSubmenu_root('ภาพรวมการขาย');
    }
    if (location.pathname.search('/seller/jobtodo') > -1) {
      setSubmenu_mode('seller/jobtodo');
      setSubmenu_root('สรุปงานที่ต้องทำ');
    }
    if (location.pathname.search('/seller/payment') > -1) {
      setSubmenu_mode('seller/payment');
      setSubmenu_root('ที่ลูกค้าต้องชำระ');
    }
    if (location.pathname.search('/seller/deliver') > -1) {
      setSubmenu_mode('seller/deliver');
      setSubmenu_root('ที่ต้องจัดส่ง');
    }
    if (location.pathname.search('/seller/transport') > -1) {
      setSubmenu_mode('seller/transport');
      setSubmenu_root('กำลังจัดส่ง');
    }
    if (location.pathname.search('/seller/return') > -1) {
      setSubmenu_mode('seller/return');
      setSubmenu_root('การคืนสินค้า');
    }
    if (location.pathname.search('/seller/income') > -1) {
      setSubmenu_mode('seller/income');
      setSubmenu_root('รอยอดโอนเข้าร้าน');
    }
    if (location.pathname.search('/seller/history') > -1) {
      setSubmenu_mode('seller/history');
      setSubmenu_root('ประวัติการขายย้อนหลัง');
    }
    if (location.pathname.search('/seller/myproduct') > -1) {
      setSubmenu_mode('seller/myproduct');
      setSubmenu_root('สินค้าของฉัน');
    }
    if (location.pathname.search('/seller/newproduct') > -1) {
      setSubmenu_mode('seller/newproduct');
      setSubmenu_root('เพิ่มสินค้าใหม่');
    }

    if (location.pathname.search('buyer/payment') > -1) {
      setSubmenu_mode('buyer/payment');
      setSubmenu_root('ที่ต้องชำระ');
    }
    if (location.pathname.search('buyer/deliver') > -1) {
      setSubmenu_mode('buyer/deliver');
      setSubmenu_root('ที่ต้องจัดส่ง');
    }
    if (location.pathname.search('buyer/recieve') > -1) {
      setSubmenu_mode('buyer/recieve');
      setSubmenu_root('ที่ต้องได้รับ');
    }
    if (location.pathname.search('buyer/return') > -1) {
      setSubmenu_mode('buyer/return');
      setSubmenu_root('คืนสินค้า');
    }
    if (location.pathname.search('buyer/refund') > -1) {
      setSubmenu_mode('buyer/refund');
      setSubmenu_root('รอโอนเงินคืน');
    }
    if (location.pathname.search('buyer/history') > -1) {
      setSubmenu_mode('buyer/history');
      setSubmenu_root('ประวัติการซื้อย้อนหลัง');
    }

    if (location.pathname.search('seller') > -1) {
      setForce_tab('ระบบขาย');
    } else if (location.pathname.search('buyer') > -1) {
      setForce_tab('ระบบซื้อ');
    }

    resetNavbarClasses();
  }, [location]);

  useEffect(() => {
    if (location.pathname === '/myshop' || location.pathname === '/myshop/') {
      const isSellerOnly = props.permitdata.user_type === USER_TYPE.SELLER;
      navigate(isSellerOnly ? '/myshop/seller/jobtodo' : '/myshop/buyer/payment', { replace: true });
    }
  }, [location.pathname, props.permitdata.user_type, navigate]);

  function getShopHomeLink() {
    if (force_tab === 'ระบบขาย') return '/myshop/seller/jobtodo';
    return '/myshop/buyer/payment';
  }

  function getRootLink(label) {
    if (label === 'ร้านค้าของฉัน') return '/myshop';
    if (label === 'ระบบขายสินค้า') return '/myshop/seller/jobtodo';
    if (label === 'ระบบซื้อสินค้า') return '/myshop/buyer/payment';
    return '/myshop';
  }

  function getSubmenuLink(label) {
    const buyerMap = {
      ที่ต้องชำระ: '/myshop/buyer/payment',
      ที่ต้องจัดส่ง: '/myshop/buyer/deliver',
      ที่ต้องได้รับ: '/myshop/buyer/recieve',
      คืนสินค้า: '/myshop/buyer/return',
      การคืนสินค้า: '/myshop/buyer/return',
      รอโอนเงินคืน: '/myshop/buyer/refund',
      ประวัติการซื้อย้อนหลัง: '/myshop/buyer/history',
    };
    const sellerMap = {
      ภาพรวมการขาย: '/myshop/seller/businessoverview',
      สรุปงานที่ต้องทำ: '/myshop/seller/jobtodo',
      ที่ลูกค้าต้องชำระ: '/myshop/seller/payment',
      ที่ต้องจัดส่ง: '/myshop/seller/deliver',
      กำลังจัดส่ง: '/myshop/seller/transport',
      การคืนสินค้า: '/myshop/seller/return',
      คืนสินค้า: '/myshop/seller/return',
      รอยอดโอนเข้าร้าน: '/myshop/seller/income',
      ประวัติการขายย้อนหลัง: '/myshop/seller/history',
      สินค้าของฉัน: '/myshop/seller/myproduct',
      เพิ่มสินค้าใหม่: '/myshop/seller/newproduct',
    };

    if (force_tab === 'ระบบขาย') return sellerMap[label] || null;
    return buyerMap[label] || sellerMap[label] || null;
  }

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) { }

  useEffect(() => {
    setData_shoporderlist(props.systemdata_shoporderlist);
  }, [props.systemdata_shoporderlist]);

  useEffect(() => {
    setData_shopitemlist(props.systemdata_shopitemlist);
  }, [props.systemdata_shopitemlist]);

  function callback_datachanged(mode, data) {
    if (mode === 'shopitem-add') {
      props.callback_maindatachange('shopitem-add', data);
    } else if (mode === 'shopitem-edit') {
      props.callback_maindatachange('shopitem-edit', data);
    } else if (mode === 'shopitem-delete') {
      props.callback_maindatachange('shopitem-delete', data);
    } else if (mode === 'shopitem-update-stock') {
      props.callback_maindatachange('shopitem-update-stock', data);
    } else if (mode === 'shoporder-updatebooking-seller') {
      props.callback_maindatachange('shoporder-updatebooking-seller', data);
    } else if (mode === 'shoporder-updatebooking-buyer') {
      props.callback_maindatachange('shoporder-updatebooking-buyer', data);
    } else if (mode === 'shoporder-updatefullstatus') {
      props.callback_maindatachange('shoporder-updatefullstatus', data);
    } else if (mode === 'shoporder-updatefullstatus-fullrecord') {
      props.callback_maindatachange('shoporder-updatefullstatus-fullrecord', data);
    } else if (mode === 'shoporder-updatefullstatus-summary') {
      props.callback_maindatachange('shoporder-updatefullstatus-summary', data);
    } else if (mode === 'shoporder-updatepayment') {
      props.callback_maindatachange('shoporder-updatepayment', data);
    } else if (mode === 'shoporder-updatepayment-method') {
      props.callback_maindatachange('shoporder-updatepayment-method', data);
    }
  }


  useEffect(() => {
    const now = new Date();
    setData_shoporder_seller_payment(
      data_shoporderlist.filter(
        (item) =>
          item.seller_shopid === props.permitdata.shop_id &&
          item.order_status === 'IV_Req' &&
          item.api_paymentstatus !== 'Success' &&
          item.api_paymentstatus !== 'Cancel',
      ),
    );
    setData_shoporder_seller_deliver(
      data_shoporderlist.filter(
        (item) =>
          item.seller_shopid === props.permitdata.shop_id &&
          ((item.order_status === 'IV_Req' && item.api_paymentstatus === 'Success') ||
            item.order_status === 'PC_Prepare' ||
            item.order_status === 'PC_C_Cancel_Req'),
      ),
    );
    setData_shoporder_seller_transport(
      data_shoporderlist.filter(
        (item) =>
          item.seller_shopid === props.permitdata.shop_id &&
          (item.order_status === 'PC_Book' ||
            item.order_status === 'PC_BookConfirm' ||
            item.order_status === 'PC_C_Book_Cancel_Req'),
      ),
    );
    setData_shoporder_seller_return(
      data_shoporderlist.filter(
        (item) =>
          item.seller_shopid === props.permitdata.shop_id &&
          (item.order_status === 'PC_RTN_Prepare' ||
            item.order_status === 'PC_RTN_Req' ||
            item.order_status === 'PC_RTN_AC' ||
            item.order_status === 'PC_RTN_Book' ||
            item.order_status === 'PC_RTN_BookConfirm'),
      ),
    );
    setData_shoporder_seller_income(
      data_shoporderlist.filter(
        (item) =>
          item.seller_shopid === props.permitdata.shop_id &&
          ((item.order_status === 'PC_RCV' && item.income_paid === false) ||
            (item.order_status === 'PC_RTN_RCV' &&
              item.return_shop_income > 0 &&
              item.income_paid === false)),
      ),
    );

    // Filter buyer payment: exclude expired orders (expiretime in the past)
    setData_shoporder_buyer_payment(
      data_shoporderlist.filter(
        (item) =>
          item.buyer_shopid === props.permitdata.shop_id &&
          item.order_status === 'IV_Req' &&
          item.api_paymentstatus !== 'Success' &&
          item.api_paymentstatus !== 'Cancel' &&
          (item.expiretime ? new Date(item.expiretime) > now : true),
      ),
    );
    setData_shoporder_buyer_deliver(
      data_shoporderlist.filter(
        (item) =>
          item.buyer_shopid === props.permitdata.shop_id &&
          ((item.order_status === 'IV_Req' && item.api_paymentstatus === 'Success') ||
            item.order_status === 'PC_Prepare' ||
            item.order_status === 'PC_Book' ||
            item.order_status === 'PC_C_Cancel_Req' ||
            item.order_status === 'PC_C_Book_Cancel_Req'),
      ),
    );
    setData_shoporder_buyer_recieve(
      data_shoporderlist.filter(
        (item) =>
          item.buyer_shopid === props.permitdata.shop_id && item.order_status === 'PC_BookConfirm',
      ),
    );
    setData_shoporder_buyer_return(
      data_shoporderlist.filter(
        (item) =>
          item.buyer_shopid === props.permitdata.shop_id &&
          (item.order_status === 'PC_RTN_Prepare' ||
            item.order_status === 'PC_RTN_Req' ||
            item.order_status === 'PC_RTN_AC' ||
            item.order_status === 'PC_RTN_Book' ||
            item.order_status === 'PC_RTN_BookConfirm'),
      ),
    );
    setData_shoporder_buyer_refund(
      data_shoporderlist.filter(
        (item) =>
          item.buyer_shopid === props.permitdata.shop_id &&
          (item.order_status === 'IV_C_Cancel' ||
            item.order_status === 'IV_V_Cancel' ||
            item.order_status === 'PC_C_Cancel_AC' ||
            item.order_status === 'PC_C_Cancel_AT' ||
            item.order_status === 'PC_V_Cancel' ||
            item.order_status === 'PC_RTN_RCV') &&
          item.refund_paid === false,
      ),
    );
  }, [data_shoporderlist, props.permitdata.shop_id]);

  function exportOrdersToCsv(rangeStart, rangeEnd) {
    const isSeller = location.pathname.indexOf('/seller') > -1;
    const view = new URLSearchParams(location.search).get('view');
    const rows = rowsForExport(rangeStart, rangeEnd);

    if (!rows || rows.length === 0) {
      setModal_popup({
        modaltype: 'general',
        headers: 'ไม่มีข้อมูล',
        message: 'ไม่มีข้อมูลสำหรับดาวน์โหลดในช่วงวันที่ที่เลือก',
        enable: true,
      });
      return;
    }

    // Build CSV header
    const header = [
      'order_id',
      'buyer_shopname',
      'buyer_shopprovince',
      'shop_subtotal',
      'shop_shipping_markup',
      'shop_total',
      'shop_servicecharge',
      'shop_income',
      'expiretime',
    ];

    const csvRows = [];
    csvRows.push(header.join(','));

    rows.forEach((o) => {
      const values = [
        `"${o.order_id || ''}"`,
        `"${(o.buyer_shopname || '').replace(/\"/g, '""')}"`,
        `"${o.buyer_shopprovince || ''}"`,
        `${Number(o.shop_subtotal || 0).toFixed(2)}`,
        `${Number(o.shop_shipping_markup || 0).toFixed(2)}`,
        `${Number(o.shop_total || 0).toFixed(2)}`,
        `${Number(o.shop_servicecharge || 0).toFixed(2)}`,
        `${Number(o.shop_income || 0).toFixed(2)}`,
        `"${o.expiretime || ''}"
      `.trim(),
      ];

      csvRows.push(values.join(','));
    });

    const csvString = csvRows.join('\n');
    const blob = new Blob(['\uFEFF' + csvString], { type: 'text/csv;charset=utf-8;' });
    const now = new Date();
    const filename = `orders_${isSeller ? 'seller' : 'buyer'}_${now.toISOString().slice(0, 10)}.csv`;
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  // Helper to get rows according to current view and optional date range
  function rowsForExport(rangeStart, rangeEnd) {
    const isSeller = location.pathname.indexOf('/seller') > -1;
    const view = new URLSearchParams(location.search).get('view');
    let rows = [];
    if (isSeller) {
      if (view === 'all') {
        rows = data_shoporderlist.filter((item) => item.seller_shopid === props.permitdata.shop_id);
      } else {
        rows = data_shoporder_seller_payment;
      }
    } else {
      if (view === 'all') {
        rows = data_shoporderlist.filter((item) => item.buyer_shopid === props.permitdata.shop_id);
      } else {
        rows = data_shoporder_buyer_payment;
      }
    }

    if ((rangeStart || rangeEnd) && rows && rows.length > 0) {
      const startDate = rangeStart ? new Date(rangeStart) : null;
      const endDate = rangeEnd ? new Date(rangeEnd) : null;
      if (endDate) endDate.setHours(23, 59, 59, 999);
      rows = rows.filter((o) => {
        if (!o.expiretime) return false;
        const d = new Date(o.expiretime);
        if (isNaN(d)) return false;
        if (startDate && d < startDate) return false;
        if (endDate && d > endDate) return false;
        return true;
      });
    }

    return rows;
  }

  const [downloadMatchCount, setDownloadMatchCount] = useState(0);

  useEffect(() => {
    if (downloadModalOpen) {
      const rows = rowsForExport(downloadRange.start, downloadRange.end);
      setDownloadMatchCount(rows.length);
    }
  }, [
    downloadModalOpen,
    downloadRange,
    data_shoporderlist,
    data_shoporder_seller_payment,
    data_shoporder_buyer_payment,
  ]);

  function callback_tabclick(label) {
    if (!label) return;
    setForce_tab(label);
    if (label === 'ระบบขาย') {
      navigate('/myshop/seller/jobtodo');
    } else if (label === 'ระบบซื้อ') {
      navigate('/myshop/buyer/payment');
    }
    // else if (label === 'เครื่องมือ') {
    //   navigate('/myshop/tools/chat');
    // } 
    else if (label === 'ร้านค้าของฉัน') {
      navigate('/myshop');
    }
  }



  function nav_shop(nav_id) {
    const navEl = document.getElementById(nav_id);
    const navPopEl = document.getElementById(nav_id + '-pop');
    if (navEl && navEl.classList && navEl.classList.contains('hs-mega-menu-opened')) {
      navEl.className = 'nav-item hs-has-mega-menu u-header__nav-item';
      if (navPopEl)
        navPopEl.className = 'hs-mega-menu w-100 u-header__sub-menu animated hs-position-left fadeOut d-none';
    } else {
      resetNavbarClasses();

      if (navEl) navEl.className = 'nav-item hs-has-mega-menu u-header__nav-item hs-mega-menu-opened';
      if (navPopEl)
        navPopEl.className = 'hs-mega-menu w-100 u-header__sub-menu animated hs-position-left slideInUp d-block';
    }
  }

  const sidebar1ref = useDetectClickOutside({ onTriggered: closeshopbar });
  function closeshopbar() {
    resetNavbarClasses();
  }

  const buyerTotal = data_shoporder_buyer_payment.length + data_shoporder_buyer_deliver.length + data_shoporder_buyer_recieve.length + data_shoporder_buyer_return.length + data_shoporder_buyer_refund.length;
  const sellerTotal = data_shoporder_seller_payment.length + data_shoporder_seller_deliver.length + data_shoporder_seller_transport.length + data_shoporder_seller_return.length + data_shoporder_seller_income.length;

  return (
    <main id='content' role='main'>
      <div className='container font-inter font-th py-3'>

        {/* ===== Mobile Top Tab Bar ===== */}
        <div className='myshop-mode-switch d-md-none'>
          <button
            type='button'
            className={'myshop-mode-btn' + (force_tab === 'ระบบซื้อ' || force_tab === '' ? ' active' : '')}
            onClick={() => callback_tabclick('ระบบซื้อ')}
          >
            <i className='fe-shopping-bag'></i>
            <span className='myshop-mode-label'>ซื้อสินค้า</span>
            {buyerTotal > 0 && <span className='myshop-mode-badge'>{buyerTotal}</span>}
          </button>
          <button
            type='button'
            className={'myshop-mode-btn' + (force_tab === 'ระบบขาย' ? ' active' : '')}
            onClick={() => callback_tabclick('ระบบขาย')}
          >
            <i className='fe-package'></i>
            <span className='myshop-mode-label'>
              ขายสินค้า
              {hasExpireAlert ? (
                <span className='myshop-alert-icon' aria-hidden='true'>
                  !
                </span>
              ) : null}
            </span>
            {sellerTotal > 0 && <span className='myshop-mode-badge'>{sellerTotal}</span>}
          </button>
        </div>

        {/* ===== Main Layout ===== */}
        <div className='myshop-main-layout'>

          {/* === Desktop Sidebar === */}
          <div className='d-none d-md-block myshop-sidebar-card'>
            <div className='myshop-sidebar-head'>
              <span className='myshop-sidebar-head-title'>ร้านค้าของฉัน</span>
            </div>
            <div className='myshop-mode-switch'>
              <button
                type='button'
                className={'myshop-mode-btn' + (force_tab === 'ระบบซื้อ' || force_tab === '' ? ' active' : '')}
                onClick={() => callback_tabclick('ระบบซื้อ')}
              >
                <i className='fe-shopping-bag'></i>
                <span className='myshop-mode-label'>ซื้อสินค้า</span>
                {buyerTotal > 0 && <span className='myshop-mode-badge'>{buyerTotal}</span>}
              </button>
              <button
                type='button'
                className={'myshop-mode-btn' + (force_tab === 'ระบบขาย' ? ' active' : '')}
                onClick={() => callback_tabclick('ระบบขาย')}
              >
                <i className='fe-package'></i>
                <span className='myshop-mode-label'>ขายสินค้า</span>
                {sellerTotal > 0 && <span className='myshop-mode-badge'>{sellerTotal}</span>}
              </button>
            </div>

            <div className='myshop-sidebar-divider'></div>

            <div className='myshop-sidebar-nav-label'>
              {force_tab === 'ระบบขาย' ? 'เมนูขาย' : 'เมนูซื้อ'}
            </div>
            {/* BUYER menu */}
            {force_tab !== 'ระบบขาย' && (
              <ul className='myshop-sidenav font-th'>
                <li>
                  <Link to='/myshop/buyer/payment' className={'myshop-sidenav-item ' + (submenu_mode === 'buyer/payment' ? 'active' : '')}>
                    <i className='fe-credit-card'></i><span>ที่ต้องชำระ</span>
                    {data_shoporder_buyer_payment.length > 0 && <span className='myshop-indicator'>{data_shoporder_buyer_payment.length}</span>}
                  </Link>
                </li>
                <li>
                  <Link to='/myshop/buyer/deliver' className={'myshop-sidenav-item ' + (submenu_mode === 'buyer/deliver' ? 'active' : '')}>
                    <i className='fe-truck'></i><span>ที่ต้องจัดส่ง</span>
                    {data_shoporder_buyer_deliver.length > 0 && <span className='myshop-indicator'>{data_shoporder_buyer_deliver.length}</span>}
                  </Link>
                </li>
                <li>
                  <Link to='/myshop/buyer/recieve' className={'myshop-sidenav-item ' + (submenu_mode === 'buyer/recieve' ? 'active' : '')}>
                    <i className='fe-gift'></i><span>ที่ต้องได้รับ</span>
                    {data_shoporder_buyer_recieve.length > 0 && <span className='myshop-indicator'>{data_shoporder_buyer_recieve.length}</span>}
                  </Link>
                </li>
                <li>
                  <Link to='/myshop/buyer/return' className={'myshop-sidenav-item ' + (submenu_mode === 'buyer/return' ? 'active' : '')}>
                    <i className='fe-refresh-ccw'></i><span>คืนสินค้า</span>
                    {data_shoporder_buyer_return.length > 0 && <span className='myshop-indicator'>{data_shoporder_buyer_return.length}</span>}
                  </Link>
                </li>
                <li>
                  <Link to='/myshop/buyer/refund' className={'myshop-sidenav-item ' + (submenu_mode === 'buyer/refund' ? 'active' : '')}>
                    <i className='fe-dollar-sign'></i><span>รอโอนเงินคืน</span>
                    {data_shoporder_buyer_refund.length > 0 && <span className='myshop-indicator'>{data_shoporder_buyer_refund.length}</span>}
                  </Link>
                </li>
                <li>
                  <Link to='/myshop/buyer/history' className={'myshop-sidenav-item ' + (submenu_mode === 'buyer/history' ? 'active' : '')}>
                    <i className='fe-clock'></i><span>ประวัติการซื้อย้อนหลัง</span>
                  </Link>
                </li>
              </ul>
            )}
            {/* SELLER menu */}
            {force_tab === 'ระบบขาย' && (
              <ul className='myshop-sidenav font-th'>
                <li className='myshop-sidenav-section'>หน้าหลัก</li>
                <li>
                  <Link to='/myshop/seller/jobtodo' className={'myshop-sidenav-item ' + (submenu_mode === 'seller/jobtodo' ? 'active' : '')}>
                    <i className='fe-check-square'></i><span>สรุปงานที่ต้องทำ</span>
                  </Link>
                </li>
                <li>
                  <Link to='/myshop/seller/businessoverview' className={'myshop-sidenav-item ' + (submenu_mode === 'seller/businessoverview' ? 'active' : '')}>
                    <i className='fe-bar-chart-2'></i><span>ภาพรวมงานขาย</span>
                  </Link>
                </li>
                <li className='myshop-sidenav-section'>คำสั่งซื้อ</li>
                <li>
                  <Link to='/myshop/seller/payment' className={'myshop-sidenav-item ' + (submenu_mode === 'seller/payment' ? 'active' : '')}>
                    <i className='fe-credit-card'></i><span>ที่ลูกค้าต้องชำระ</span>
                    {data_shoporder_seller_payment.length > 0 && <span className='myshop-indicator'>{data_shoporder_seller_payment.length}</span>}
                  </Link>
                </li>
                <li>
                  <Link to='/myshop/seller/deliver' className={'myshop-sidenav-item ' + (submenu_mode === 'seller/deliver' ? 'active' : '')}>
                    <i className='fe-truck'></i><span>ที่ต้องจัดส่ง</span>
                    {data_shoporder_seller_deliver.length > 0 && <span className='myshop-indicator'>{data_shoporder_seller_deliver.length}</span>}
                  </Link>
                </li>
                <li>
                  <Link to='/myshop/seller/transport' className={'myshop-sidenav-item ' + (submenu_mode === 'seller/transport' ? 'active' : '')}>
                    <i className='fe-navigation'></i><span>กำลังจัดส่ง</span>
                    {data_shoporder_seller_transport.length > 0 && <span className='myshop-indicator'>{data_shoporder_seller_transport.length}</span>}
                  </Link>
                </li>
                <li>
                  <Link to='/myshop/seller/return' className={'myshop-sidenav-item ' + (submenu_mode === 'seller/return' ? 'active' : '')}>
                    <i className='fe-corner-up-left'></i><span>การคืนสินค้า</span>
                    {data_shoporder_seller_return.length > 0 && <span className='myshop-indicator'>{data_shoporder_seller_return.length}</span>}
                  </Link>
                </li>
                <li>
                  <Link to='/myshop/seller/income' className={'myshop-sidenav-item ' + (submenu_mode === 'seller/income' ? 'active' : '')}>
                    <i className='fe-dollar-sign'></i><span>รอยอดโอนเข้าร้าน</span>
                    {data_shoporder_seller_income.length > 0 && <span className='myshop-indicator'>{data_shoporder_seller_income.length}</span>}
                  </Link>
                </li>
                <li>
                  <Link to='/myshop/seller/history' className={'myshop-sidenav-item ' + (submenu_mode === 'seller/history' ? 'active' : '')}>
                    <i className='fe-clock'></i><span>ประวัติการขายย้อนหลัง</span>
                  </Link>
                </li>
                <li className='myshop-sidenav-section'>สินค้า</li>
                <li>
                  <Link to='/myshop/seller/myproduct' className={'myshop-sidenav-item ' + (submenu_mode === 'seller/myproduct' ? 'active' : '')}>
                    <i className='fe-box'></i>
                    <span>
                      สินค้าของฉัน
                      {hasExpireAlert ? (
                        <span className='myshop-alert-icon' aria-hidden='true'>
                          !
                        </span>
                      ) : null}
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to='/myshop/seller/newproduct' className={'myshop-sidenav-item ' + (submenu_mode === 'seller/newproduct' ? 'active' : '')}>
                    <i className='fe-plus-circle'></i><span>เพิ่มสินค้าใหม่</span>
                  </Link>
                </li>
              </ul>
            )}
          </div>

          {/* === Right Column: Header + Content === */}
          <div className='myshop-right-col'>
            <div className='myshop-page-header-card'>
              <div className='myshop-section-header'>
                <nav aria-label='breadcrumb' className='w-100 d-none d-md-block'>
                  <ol className='modern-breadcrumb mb-2'>
                    <li className='breadcrumb-item'>
                      <Link to={'/marketplace?category=รวมสินค้า'} className='home-link'>
                        <i className='fe-home'></i>
                      </Link>
                    </li>
                    <li className='breadcrumb-item'>
                      <Link to={getShopHomeLink()}>ร้านค้าของฉัน</Link>
                    </li>
                    {menu_root && (
                      <li className='breadcrumb-item'>
                        <Link to={getRootLink(menu_root)}>{menu_root}</Link>
                      </li>
                    )}
                    {submenu_root && (
                      <li className='breadcrumb-item active'>
                        <span>{submenu_root}</span>
                      </li>
                    )}
                  </ol>
                </nav>
                <h2 className='myshop-section-title'>{submenu_root || menu_root || 'ร้านค้าของฉัน'}</h2>
              </div>
            </div>

            {/* === Content Area === */}
            <div className='myshop-content-panel'>
              <div className='myshop-content-col'>
            {/* Horizontal Sub-menu for Mobile */}
            <div className='mobile-submenu-wrapper d-md-none'>
              <div className='mobile-submenu-scroll'>
                <button
                  className='mobile-submenu-item menu-toggle'
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                  <i className={isMobileMenuOpen ? 'fe-x' : 'fe-menu'}></i>
                </button>
                {force_tab !== 'ระบบขาย' ? (
                  <>
                    <Link to='/myshop/buyer/payment' className={'mobile-submenu-item ' + (submenu_mode === 'buyer/payment' ? 'active' : '')}>ที่ต้องชำระ</Link>
                    <Link to='/myshop/buyer/deliver' className={'mobile-submenu-item ' + (submenu_mode === 'buyer/deliver' ? 'active' : '')}>ที่ต้องจัดส่ง</Link>
                    <Link to='/myshop/buyer/recieve' className={'mobile-submenu-item ' + (submenu_mode === 'buyer/recieve' ? 'active' : '')}>ที่ต้องได้รับ</Link>
                    <Link to='/myshop/buyer/return' className={'mobile-submenu-item ' + (submenu_mode === 'buyer/return' ? 'active' : '')}>คืนสินค้า</Link>
                    <Link to='/myshop/buyer/refund' className={'mobile-submenu-item ' + (submenu_mode === 'buyer/refund' ? 'active' : '')}>รอโอนเงินคืน</Link>
                    <Link to='/myshop/buyer/history' className={'mobile-submenu-item ' + (submenu_mode === 'buyer/history' ? 'active' : '')}>ประวัติ</Link>
                  </>
                ) : (
                  <>
                    <Link to='/myshop/seller/jobtodo' className={'mobile-submenu-item ' + (submenu_mode === 'seller/jobtodo' ? 'active' : '')}>สรุปงาน</Link>
                    <Link to='/myshop/seller/businessoverview' className={'mobile-submenu-item ' + (submenu_mode === 'seller/businessoverview' ? 'active' : '')}>ภาพรวม</Link>
                    <Link to='/myshop/seller/payment' className={'mobile-submenu-item ' + (submenu_mode === 'seller/payment' ? 'active' : '')}>รอชำระ</Link>
                    <Link to='/myshop/seller/deliver' className={'mobile-submenu-item ' + (submenu_mode === 'seller/deliver' ? 'active' : '')}>จัดส่ง</Link>
                    <Link to='/myshop/seller/transport' className={'mobile-submenu-item ' + (submenu_mode === 'seller/transport' ? 'active' : '')}>ขนส่ง</Link>
                    <Link to='/myshop/seller/return' className={'mobile-submenu-item ' + (submenu_mode === 'seller/return' ? 'active' : '')}>คืนสินค้า</Link>
                    <Link to='/myshop/seller/income' className={'mobile-submenu-item ' + (submenu_mode === 'seller/income' ? 'active' : '')}>รอยอด</Link>
                    <Link to='/myshop/seller/history' className={'mobile-submenu-item ' + (submenu_mode === 'seller/history' ? 'active' : '')}>ประวัติ</Link>
                    <Link to='/myshop/seller/myproduct' className={'mobile-submenu-item ' + (submenu_mode === 'seller/myproduct' ? 'active' : '')}>สินค้า</Link>
                  </>
                )}
              </div>

              {/* Modern Vertical Menu Overlay */}
              {isMobileMenuOpen && (
                <div className='mobile-nav-overlay' onClick={() => setIsMobileMenuOpen(false)}>
                  <div className='mobile-nav-dropdown' onClick={(e) => e.stopPropagation()}>
                    {force_tab === 'ระบบขาย' ? (
                      <>
                        <div className='nav-group-title'>หน้าหลัก</div>
                        <Link to='/myshop/seller/jobtodo' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'seller/jobtodo' ? 'active' : '')}>
                          <i className='fe-check-square'></i><span>สรุปงานที่ต้องทำ</span>
                        </Link>
                        <Link to='/myshop/seller/businessoverview' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'seller/businessoverview' ? 'active' : '')}>
                          <i className='fe-bar-chart-2'></i><span>ภาพรวมงานขาย</span>
                        </Link>

                        <div className='nav-group-title'>คำสั่งซื้อ</div>
                        <Link to='/myshop/seller/payment' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'seller/payment' ? 'active' : '')}>
                          <i className='fe-credit-card'></i><span>ที่ลูกค้าต้องชำระ</span>
                          {data_shoporder_seller_payment.length > 0 && <span className='indicator'>{data_shoporder_seller_payment.length}</span>}
                        </Link>
                        <Link to='/myshop/seller/deliver' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'seller/deliver' ? 'active' : '')}>
                          <i className='fe-truck'></i><span>ที่ต้องจัดส่ง</span>
                          {data_shoporder_seller_deliver.length > 0 && <span className='indicator'>{data_shoporder_seller_deliver.length}</span>}
                        </Link>
                        <Link to='/myshop/seller/transport' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'seller/transport' ? 'active' : '')}>
                          <i className='fe-send'></i><span>กำลังจัดส่ง</span>
                          {data_shoporder_seller_transport.length > 0 && <span className='indicator'>{data_shoporder_seller_transport.length}</span>}
                        </Link>
                        <Link to='/myshop/seller/return' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'seller/return' ? 'active' : '')}>
                          <i className='fe-refresh-ccw'></i><span>การคืนสินค้า</span>
                          {data_shoporder_seller_return.length > 0 && <span className='indicator'>{data_shoporder_seller_return.length}</span>}
                        </Link>
                        <Link to='/myshop/seller/income' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'seller/income' ? 'active' : '')}>
                          <i className='fe-dollar-sign'></i><span>รอยอดโอนเข้าร้าน</span>
                          {data_shoporder_seller_income.length > 0 && <span className='indicator'>{data_shoporder_seller_income.length}</span>}
                        </Link>
                        <Link to='/myshop/seller/history' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'seller/history' ? 'active' : '')}>
                          <i className='fe-clock'></i><span>ประวัติการขายย้อนหลัง</span>
                        </Link>

                        <div className='nav-group-title'>สินค้า</div>
                        <Link to='/myshop/seller/myproduct' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'seller/myproduct' ? 'active' : '')}>
                          <i className='fe-box'></i>
                          <span>
                            สินค้าของฉัน
                            {hasExpireAlert ? (
                              <span className='myshop-alert-icon' aria-hidden='true'>
                                !
                              </span>
                            ) : null}
                          </span>
                        </Link>
                        <Link to='/myshop/seller/newproduct' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'seller/newproduct' ? 'active' : '')}>
                          <i className='fe-plus-circle'></i><span>เพิ่มสินค้าใหม่</span>
                        </Link>
                      </>
                    ) : (
                      <>
                        <div className='nav-group-title'>หน้าหลัก</div>
                        <Link to='/myshop/buyer/payment' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'buyer/payment' ? 'active' : '')}>
                          <i className='fe-credit-card'></i><span>ที่ต้องชำระ</span>
                          {data_shoporder_buyer_payment.length > 0 && <span className='indicator'>{data_shoporder_buyer_payment.length}</span>}
                        </Link>
                        <Link to='/myshop/buyer/deliver' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'buyer/deliver' ? 'active' : '')}>
                          <i className='fe-truck'></i><span>ที่ต้องจัดส่ง</span>
                          {data_shoporder_buyer_deliver.length > 0 && <span className='indicator'>{data_shoporder_buyer_deliver.length}</span>}
                        </Link>
                        <Link to='/myshop/buyer/recieve' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'buyer/recieve' ? 'active' : '')}>
                          <i className='fe-gift'></i><span>ที่ต้องได้รับ</span>
                          {data_shoporder_buyer_recieve.length > 0 && <span className='indicator'>{data_shoporder_buyer_recieve.length}</span>}
                        </Link>
                        <Link to='/myshop/buyer/return' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'buyer/return' ? 'active' : '')}>
                          <i className='fe-refresh-ccw'></i><span>คืนสินค้า</span>
                          {data_shoporder_buyer_return.length > 0 && <span className='indicator'>{data_shoporder_buyer_return.length}</span>}
                        </Link>
                        <Link to='/myshop/buyer/refund' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'buyer/refund' ? 'active' : '')}>
                          <i className='fe-dollar-sign'></i><span>รอโอนเงินคืน</span>
                          {data_shoporder_buyer_refund.length > 0 && <span className='indicator'>{data_shoporder_buyer_refund.length}</span>}
                        </Link>
                        <Link to='/myshop/buyer/history' onClick={() => setIsMobileMenuOpen(false)} className={'nav-dropdown-item ' + (submenu_mode === 'buyer/history' ? 'active' : '')}>
                          <i className='fe-clock'></i><span>ประวัติการซื้อย้อนหลัง</span>
                        </Link>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>

            <Routes>
              <Route
                index
                element={
                  <Navigate
                    to={
                      props.permitdata.user_type === USER_TYPE.SELLER
                        ? 'seller/jobtodo'
                        : 'buyer/payment'
                    }
                    replace
                  />
                }
              />
              <Route
                path='/seller/jobtodo'
                element={
                  props.permitdata.user_type === USER_TYPE.SELLER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Seller_JobToDo
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporderlist={data_shoporderlist}
                      data_shopitemlist={data_shopitemlist}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    />
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/seller/businessoverview'
                element={
                  props.permitdata.user_type === USER_TYPE.SELLER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Seller_BusinessOverview
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                    ></MyShop_Seller_BusinessOverview>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/seller/payment'
                element={
                  props.permitdata.user_type === USER_TYPE.SELLER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Seller_Payment
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporder_seller_payment={data_shoporder_seller_payment}
                      data_shoporder_seller_all={data_shoporderlist.filter(
                        (item) => item.seller_shopid === props.permitdata.shop_id,
                      )}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    ></MyShop_Seller_Payment>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/seller/deliver'
                element={
                  props.permitdata.user_type === USER_TYPE.SELLER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Seller_Deliver
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporder_seller_deliver={data_shoporder_seller_deliver}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    ></MyShop_Seller_Deliver>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/seller/transport'
                element={
                  props.permitdata.user_type === USER_TYPE.SELLER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Seller_Transport
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporder_seller_transport={data_shoporder_seller_transport}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    ></MyShop_Seller_Transport>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/seller/return'
                element={
                  props.permitdata.user_type === USER_TYPE.SELLER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Seller_Return
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporder_seller_return={data_shoporder_seller_return}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    ></MyShop_Seller_Return>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/seller/income'
                element={
                  props.permitdata.user_type === USER_TYPE.SELLER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Seller_Income
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporder_seller_return={data_shoporder_seller_income}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    ></MyShop_Seller_Income>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/seller/history'
                element={
                  props.permitdata.user_type === USER_TYPE.SELLER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Seller_History
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporder_seller_all={data_shoporderlist.filter(
                        (item) => item.seller_shopid === props.permitdata.shop_id,
                      )}
                    ></MyShop_Seller_History>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/seller/myproduct'
                element={
                  props.permitdata.user_type === USER_TYPE.SELLER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Seller_MyProduct
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    ></MyShop_Seller_MyProduct>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/seller/newproduct'
                element={
                  props.permitdata.user_type === USER_TYPE.SELLER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Seller_NewProduct
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      systemdata_productcategorylist={props.systemdata_productcategorylist}
                      productCatalog={props.productCatalog}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    ></MyShop_Seller_NewProduct>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />

              <Route
                path='/buyer/payment'
                element={
                  props.permitdata.user_type === USER_TYPE.BUYER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Buyer_Payment
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporder_buyer_payment={data_shoporder_buyer_payment}
                      data_shoporder_buyer_all={data_shoporderlist.filter(
                        (item) => item.buyer_shopid === props.permitdata.shop_id,
                      )}
                      callback_mycart={(mode, data) => {
                        props.callback_mycart(mode, data);
                      }}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    ></MyShop_Buyer_Payment>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/buyer/deliver'
                element={
                  props.permitdata.user_type === USER_TYPE.BUYER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Buyer_Deliver
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporder_buyer_deliver={data_shoporder_buyer_deliver}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    ></MyShop_Buyer_Deliver>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/buyer/recieve'
                element={
                  props.permitdata.user_type === USER_TYPE.BUYER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Buyer_Recieve
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporder_buyer_recieve={data_shoporder_buyer_recieve}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    ></MyShop_Buyer_Recieve>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/buyer/return'
                element={
                  props.permitdata.user_type === USER_TYPE.BUYER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Buyer_Return
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporder_buyer_return={data_shoporder_buyer_return}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    ></MyShop_Buyer_Return>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/buyer/refund'
                element={
                  props.permitdata.user_type === USER_TYPE.BUYER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Buyer_Refund
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporder_buyer_refund={data_shoporder_buyer_refund}
                      callback_datachanged={(mode, data) => {
                        callback_datachanged(mode, data);
                      }}
                    ></MyShop_Buyer_Refund>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />
              <Route
                path='/buyer/history'
                element={
                  props.permitdata.user_type === USER_TYPE.BUYER ||
                    props.permitdata.user_type === USER_TYPE.ALL ? (
                    <MyShop_Buyer_History
                      app_hostname={props.app_hostname}
                      permitdata={props.permitdata}
                      data_shoporder_buyer_all={data_shoporderlist.filter(
                        (item) => item.buyer_shopid === props.permitdata.shop_id,
                      )}
                    ></MyShop_Buyer_History>
                  ) : (
                    <AccessRestrictedMessage userType={props.permitdata.user_type} />
                  )
                }
              />

              <Route
                path='/tools/chat'
                element={
                  <MyShop_Tools_Chat
                    app_hostname={props.app_hostname}
                    permitdata={props.permitdata}
                    messages_chat_buffer={props.messages_chat_buffer}
                    isConnectionOpen_notify={props.isConnectionOpen_notify}
                    notify_ws={props.notify_ws}
                  ></MyShop_Tools_Chat>
                }
              />
            </Routes>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
    </main>
  );
}

MyShopPage.propTypes = {
  callback_maindatachange: PropTypes.func,
};

export default MyShopPage;
